var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeginerBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.332,
    width: 4,
    height: 18,
    rx: 2,
    fill: "#007C3B",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.33203,
    y: 6,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#007C3B",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    y: 12,
    width: 4,
    height: 6,
    rx: 2,
    fill: "#007C3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginerBar);
export default __webpack_public_path__ + "static/media/beginerBar.803b1821c90fb035e95cce5ed0d3b26c.svg";
export { ForwardRef as ReactComponent };